import { render, staticRenderFns } from "./ManageProfileEditForm.vue?vue&type=template&id=a0681648"
import script from "./ManageProfileEditForm.vue?vue&type=script&lang=js"
export * from "./ManageProfileEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports